export default "__VITE_ASSET__Diw0iNKj__"